import React from "react";
import { num } from "./api";

/*
 * The §7.4 resolution funnel: every subtraction between "in included lists"
 * and "recipients", rendered like mockup 2 (wizard estimate) and mockup 4
 * (resolved at send time, compact: one summed minus line).
 *
 * f = EstimateResult { inLists, excluded, duplicates, suppressed, noConsent,
 *     inactive, frequencyCap, invalid, recipients, computedDate, estimateOnly, notes }
 */

const LINES = [["excluded", "− in excluded lists"], ["duplicates", "− duplicates (same person / same address)"], ["suppressed", "− suppressed (bounced, complained, unsubscribed)"], ["noConsent", "− no email consent"], ["inactive", "− inactive"], ["frequencyCap", "− frequency cap"], ["invalid", "− invalid, role or disposable address"]];
export default function Funnel({
  f,
  compact = false,
  pending = false,
  emptyText
}) {
  if (!f) return /*#__PURE__*/React.createElement("div", {
    className: "ec-funnel-empty"
  }, pending ? "Estimating…" : emptyText || "Add an include list to see who gets this.");
  const inLists = Number(f.inLists) || 0;
  const recipients = Number(f.recipients) || 0;
  const w = n => inLists > 0 ? `${Math.max(0, Math.min(100, (Number(n) || 0) / inLists * 100))}%` : "0%";
  const minusTotal = LINES.reduce((t, [k]) => t + (Number(f[k]) || 0), 0);
  return /*#__PURE__*/React.createElement("div", {
    className: "ec-funnel" + (pending ? " pending" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "f top"
  }, /*#__PURE__*/React.createElement("span", null, "In included lists"), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, num(inLists))), /*#__PURE__*/React.createElement("div", {
    className: "f bar"
  }, /*#__PURE__*/React.createElement("span", {
    className: "b"
  }, /*#__PURE__*/React.createElement("i", {
    style: {
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("span", null)), compact ? /*#__PURE__*/React.createElement("div", {
    className: "f minus"
  }, /*#__PURE__*/React.createElement("span", null, "\u2212 excluded \xB7 duplicates \xB7 suppressed \xB7 no consent \xB7 inactive \xB7 cap \xB7 invalid"), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, "\u2212", num(minusTotal))) : LINES.map(([k, label]) => /*#__PURE__*/React.createElement("div", {
    className: "f minus" + (Number(f[k]) > 0 ? "" : " zero"),
    key: k
  }, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, "\u2212", num(f[k] || 0)))), /*#__PURE__*/React.createElement("div", {
    className: "f total"
  }, /*#__PURE__*/React.createElement("span", null, "Recipients ", /*#__PURE__*/React.createElement("span", {
    className: "b"
  }, /*#__PURE__*/React.createElement("i", {
    style: {
      width: w(recipients)
    }
  }))), /*#__PURE__*/React.createElement("span", {
    className: "v"
  }, num(recipients))));
}